import React from 'react';

import PortfolioTextPane from './PortfolioTextPane'
// material
import Grid from '@material-ui/core/Grid'

// Images

export default class PortfolioItem extends React.Component{
 render(){
  return(
  	<section>
  		<div className="container PortfolioItem">
  			<Grid direction={this.props.rowDirection} container alignItems="center" justify="center">
          <Grid item md={6} xs={12} className="PortfolioImage" style={{textAlign: `${this.props.alignImg}`}}>
					 <img className="PortfolioImg" style={{maxHeight: `${this.props.height}`}} src={this.props.img} alt=""/>
  				</Grid>
  				<Grid item md={6} xs={12} className="PortfolioText" style={{textAlign: `${this.props.alignText}`}}>
  					<PortfolioTextPane colorTitle={this.props.colorTitle} colorSubtitle={this.props.colorSubtitle} colorText={this.props.colorText} title={this.props.title} subtitle={this.props.subtitle} text={this.props.text} textNoLink={this.props.textNoLink}/>
  				</Grid>
  			</Grid>
  		</div>
  	</section>
  );
 }
}


// WEBPACK FOOTER //
// ./src/Components/Utilities/PortfolioItem.js